<template lang="">
<div>
  <!-------------------------------- BLOC CREER UN RAPPEL -------------------------------->
  <v-col cols="12" sm="10" class="pb-0 mt-10">
    <v-toolbar color="#0B87BA" flat dense>
      <v-col cols="6" lg="6" xl="2" class="pa-0 font_color text-left">
        RAPPELS
      </v-col>
      <v-col cols="6" lg="6" xl="4" offset-xl="6" class="pa-0 text-right">
        <v-btn
          v-if="mode !== 'visualisation'"
          class="btnBold"
          color="#FF9900"
          dark rounded
          @click="dialog = true"
        >
          <v-icon left>fa fa-plus</v-icon>
          Ajouter rappel
        </v-btn>
      </v-col>
    </v-toolbar>
  </v-col>

  <!-- ── Modal : Ajouter un rappel ──────────────────────────────── -->
  <v-dialog v-model="dialog" max-width="500">
    <v-card class="cmodal-card">

      <div class="cmodal-header">
        <span class="cmodal-title">Ajouter un rappel</span>
        <v-btn icon dark small @click="dialog = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pa-5">
        <form @submit.prevent="submit">

          <!-- Urgent toggle -->
          <div class="field-group mb-5">
            <div class="field-label">Priorité</div>
            <button
              type="button"
              class="urgent-btn mt-1"
              :class="{ 'urgent-btn--active': rappel.urgent }"
              @click="rappel.urgent = !rappel.urgent"
            >
              <v-icon small :color="rappel.urgent ? '#fff' : '#c62828'" class="mr-1">
                mdi-alert
              </v-icon>
              URGENT
            </button>
          </div>

          <!-- Date du rappel -->
          <div class="field-group mb-5">
            <div class="field-label">Date du rappel <span class="required">*</span></div>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              light
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formatDate"
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  hide-details="auto"
                  prepend-inner-icon="mdi-calendar"
                  :error-messages="$v.rappel.date_rappel.$error ? ['Renseignez la date du rappel.'] : []"
                />
              </template>
              <v-date-picker
                v-model="rappel.date_rappel"
                no-title
                locale="fr-fr"
                @input="menu1 = false"
              />
            </v-menu>
          </div>

          <!-- Commentaire -->
          <div class="field-group mb-5">
            <div class="field-label">Commentaire <span class="required">*</span></div>
            <v-textarea
              v-model="rappel.commentaire"
              outlined
              auto-grow
              rows="3"
              hide-details="auto"
              :error-messages="$v.rappel.commentaire.$error ? ['Renseignez un commentaire.'] : []"
            />
          </div>

          <v-divider class="mb-4" />

          <div class="d-flex justify-end">
            <v-btn text class="mr-2" @click="dialog = false">Annuler</v-btn>
            <v-btn color="#FF9900" dark rounded depressed type="submit">
              <v-icon left small>mdi-bell-plus</v-icon>
              Ajouter ce rappel
            </v-btn>
          </div>

        </form>
      </v-card-text>

    </v-card>
  </v-dialog>

  <!-- ── Modal : Supprimer un rappel ────────────────────────────── -->
  <Popup
    :dialog="dialogDelete"
    text="Supprimer ce rappel ?"
    actions=""
    heightProp=""
    widthProp=""
    @emitDialog="dialogDelete = $event"
    showClose="false"
  >
    <v-card-actions class="mb-10">
      <v-btn class="actions mr-10" color="#0B87BA" width="100px" large dark rounded @click="closeDelete">Non</v-btn>
      <v-btn class="actions" color="#0B87BA" width="100px" large dark rounded @click="deleteItemConfirm">Oui</v-btn>
    </v-card-actions>
  </Popup>

  <!-- ── Modal : Clore un rappel ────────────────────────────────── -->
  <Popup
    :dialog="dialogCloseRappel"
    text="Êtes vous sûr de vouloir clore ce rappel ?"
    actions=""
    heightProp=""
    widthProp=""
    @emitDialog="dialogCloseRappel = $event"
    showClose="false"
  >
    <v-card-actions class="mb-10">
      <v-btn class="actions mr-10" color="#0B87BA" width="100px" large dark rounded @click="dialogCloseRappel = false">Non</v-btn>
      <v-btn class="actions" color="#0B87BA" width="100px" large dark rounded @click="closeRappelConfirm">Oui</v-btn>
    </v-card-actions>
  </Popup>

  <!-- ── Tableau des rappels ────────────────────────────────────── -->
  <v-col cols="12" sm="10" class="pb-0 mt-10">
    <v-data-table
      v-if="rappels.length > 0"
      :headers="headers"
      :items="rappels"
      :items-per-page="50"
      hide-default-footer
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon v-if="item.id_rappel === undefined && item.actif === 1" small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
        <v-icon v-else-if="item.id_rappel !== undefined && item.actif === 1" small @click="closeRappel(item)">
          mdi-close
        </v-icon>
      </template>

      <template v-slot:item.date_rappel="{ item }">
        {{ item.date_rappel ? $moment(item.date_rappel).format("DD/MM/YYYY") : "" }}
      </template>

      <template v-slot:item.urgent="{ item }">
        {{ item.urgent ? "Oui" : "Non" }}
      </template>

      <template v-slot:item.actif="{ item }">
        {{ item.actif === 1 && item.actif ? "Oui" : "Non" }}
      </template>
    </v-data-table>
  </v-col>
</div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Popup from "@/components/shared/Popup";
import moment from "moment";

export default {
  props: {
    rappels: {
      type: Array,
      default: () => [],
    },
    mode: [String],
  },
  components: { Popup },
  data() {
    return {
      headers: [
        { text: 'Date', align: 'start', value: 'date_rappel', sortable: false },
        { text: 'Commentaire', value: 'description', sortable: false },
        { text: 'Urgent', value: 'urgent', sortable: false },
        { text: 'Actif', value: 'actif', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      dialogDelete: false,
      dialogCloseRappel: false,
      cloreRappel: null,
      dialog: false,
      menu1: false,
      rappel: {
        urgent: false,
        date_rappel: "",
        commentaire: "",
      },
    };
  },
  validations: {
    rappel: {
      date_rappel: { required },
      commentaire: { required },
    },
  },
  computed: {
    formatDate() {
      return this.rappel.date_rappel
        ? moment(this.rappel.date_rappel).format("L")
        : "";
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.dialog = false;
        this.rappels.push({
          date_rappel: this.rappel.date_rappel,
          description: this.rappel.commentaire,
          urgent: this.rappel.urgent,
          actif: 1,
        });
        this.rappel = { urgent: false, date_rappel: "", commentaire: "" };
        this.$v.$reset();
      }
    },
    deleteItem(item) {
      this.editedIndex = this.rappels.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.rappels.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    closeRappel(item) {
      this.dialogCloseRappel = true;
      this.cloreRappel = item;
    },
    closeRappelConfirm() {
      this.dialogCloseRappel = false;
      this.$emit("closeRappel", { id_rappel: this.cloreRappel.id_rappel });
    },
  },
  mounted() {
    if (this.mode === "visualisation") {
      this.headers = [
        { text: 'Date', align: 'start', value: 'date_rappel', sortable: false },
        { text: 'Commentaire', value: 'description', sortable: false },
        { text: 'Urgent', value: 'urgent', sortable: false },
        { text: 'Actif', value: 'actif', sortable: false },
      ];
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

// ── Modal card ────────────────────────────────────────────────────
.cmodal-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.cmodal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #0a6e97;
  color: #fff;
}

.cmodal-title {
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

// ── Form fields ───────────────────────────────────────────────────
.field-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  color: #777;
  text-transform: uppercase;
  margin-bottom: 4px;

  .required {
    color: #e53935;
  }
}

// ── Urgent toggle ─────────────────────────────────────────────────
.urgent-btn {
  display: inline-flex;
  align-items: center;
  padding: 7px 18px;
  border-radius: 20px;
  border: 2px solid #c62828;
  background: #fff;
  font-weight: 700;
  font-size: 0.82rem;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  color: #c62828;
  outline: none;

  &:hover {
    background: #fdecea;
  }

  &--active {
    background: #c62828;
    color: #fff;
  }
}

// ── Misc ──────────────────────────────────────────────────────────
.font_color {
  font-weight: bold;
  color: #ffffff;
}

.btnBold {
  font-weight: bold;
}

.actions {
  padding: 2% 5%;
  font-weight: bold;
  font-size: 1.2em;
}

::v-deep .menu-chips.theme--dark.v-list,
.v-chip.v-chip--clickable.v-chip--no-color.v-chip--pill.v-chip--removable.theme--light.v-size--default,
::v-deep .v-icon.notranslate.v-chip__close.v-icon--link.v-icon--right.mdi.mdi-delete.theme--light {
  background: $background-color-blue;
  color: #fff;
}
</style>
